export default __webpack_public_path__ + "static/media/Sasi_Preetham_Pamarthi.c448d380.jpeg";